module.exports = __webpack_public_path__ + "static/media/INSIDER_BG_DASHBOARD_ENCONTRO_LOGO_SEM_R_CLARO.58b1a4a0.png";